import {Button, Heading, List, ListIcon, ListItem, Text, Box, useColorModeValue, VStack} from "@chakra-ui/react";
import React from "react";
import {Activity} from "../models/activity";
import {MdSportsFootball} from "react-icons/md";

interface Props {
  activities: Activity[];
  buttonActionOnClick: () => void;
}

export default function ActivityFeesForMembershipFee(props: Props) {

  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const secondaryTextColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Box
      bg={cardBg}
      p={6}
      borderRadius="lg"
      border="1px solid"
      borderColor={borderColor}
      boxShadow="lg"
      width="100%"
    >
      <VStack spacing={4} align="stretch">
        <Heading as="h2" size="md">Aranceles de actividades</Heading>
        <Text color={secondaryTextColor}>
          Junto con el pago de tus cuotas sociales, también estás abonando los aranceles de las siguientes actividades:
        </Text>
        <List spacing={3}>
          {
            props.activities.map(x =>
              !x.isInsurance ? <ListItem key={x.id}><ListIcon as={MdSportsFootball} />{x.name}</ListItem> : null
            )
          }
        </List>
        <Text color={secondaryTextColor}>
          Si únicamente querés abonar las cuotas sociales, hacé click acá:
        </Text>
        <Button colorScheme="blue" onClick={props.buttonActionOnClick}>
          Abonar sólo cuotas sociales
        </Button>
      </VStack>
    </Box>
  )
}
